// ControlSubmitButtonFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import SubmitButtonControlView from 'common-visuals/SubmitButtonControlView.js';

//=============================================================================
//
// This singleton creates a submit button control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Lou Mauget, December 8, 2015 
//
//=============================================================================
class ControlSubmitButtonFactory extends BaseVisualControlFactory {
	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
		//adding silent(accessibility) to attributes.
		attributes.silent = false;
		attributes.text = 'Submit';
		attributes.borderStyle = 'solid';
		attributes.inlineEditable = true;
		attributes.buttonStyle ='~buttonStyle';
		attributes.styleColorText ='~buttonTextColor';
		attributes.styleColorTextDown ='~buttonTextDownColor';
		attributes.styleColorTextOver ='~buttonTextOverColor';
		attributes.fontFamily = '~buttonFont';
		attributes.fontSize = '~buttonFont';
		attributes.textWeight = '~buttonFont';
		attributes.textStyle  = '~buttonFont';
		attributes.cornerRadius= '~buttonRadius';
		attributes.borderColor = '~buttonBorderColor';
		attributes.backgroundColor = '~buttonBgColor';
		attributes.advancedBgGradientColor = '~buttonBgGradientColor';
		attributes.advancedBgColorOver = '~buttonBgOverColor';
		attributes.advancedBgGradientColorOver = '~buttonBgGradientOverColor';
		attributes.advancedBgColorDown = '~buttonBgDownColor';
		attributes.advancedBgGradientColorDown = '~buttonBgGradientDownColor';
        attributes.resizePadding = 2;
        attributes.resizePaddingH = 0;
		attributes.minWidth = 10;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
		attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"toolTip", label:"Tooltip"}
        ];

		return new SubmitButtonControlView( { model: new ControlModel( attributes ), el: $(constants.FORM_ID),
            							pos: pos, factoryKey: factoryKey, id: attributes.id } );
	}

}

const controlSubmitButtonFactory = new ControlSubmitButtonFactory();

// Expose signglon only
export default controlSubmitButtonFactory;
